export default __webpack_public_path__ + "static/media/locked.5c3785a0.svg";